import { TweenLite, TimelineMax, TimelineLite } from "gsap";
import { IInterval } from "../../../Context/Interval";
import { ISystemContext } from "../../../Context/SystemContext";
import { BackendSettings } from "../../../help/Help";
import { Resourceful } from "../../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { PayTable } from "../../../slot/Paytable/Paytable";
import { SlotGameMessages } from "../../../slot/SlotGameScreenMessages";
import { SlotSymbolSprite } from "../../../slot/SlotSymbolSprite";
import { SlotGameInitData } from "../../../SlotGameInitData";
import { Translator } from "../../../Translator";
import { LogGroup, Size, CreateElement, Scale, Log, SetStyles } from "../../.././MyHelpers";
import { IGenericSlider } from "../GenericSlider";
import { SlideFactory2Side } from "./SlideFactory2Side";
import { Slide, SlideFactory2Params } from "./Slides/Slide";
import { Settings } from "../../../Settings";
import { SlideType } from "./SlideType";
import { SlotSymbol } from "../../SlotSymbol";
import { IBackendSettingsService } from "../../../../services/BackendSettingsService";
import { ITimeout } from "../../../Context/Timeout";

export interface SecondScreenHelpParams
{
	gameName: string,
	systemContext: ISystemContext;
	initData: SlotGameInitData;
	resid: ResourceIdentifier;
	translator: Translator;
	logGroup: LogGroup;
	symbolSpriteAnims: SlotSymbolSprite[];
	viewSize: Size;
	backendSettings: IBackendSettingsService;
    availableSymbols: SlotSymbol[];
}

export class SecondSceenHelp2Slides implements Resourceful, IGenericSlider {

    protected view: HTMLElement = null;
    protected initData: SlotGameInitData;
    protected resid: ResourceIdentifier;
    protected gamePath: string = "";
    protected commonPath: string = "";
    //protected commonPath2: string = "";
    //protected commonPath3: string = "";


	protected readonly nextSlideInterval: number = 10 * 1000;
	
    protected translator: Translator;
    protected systemContext: ISystemContext;
    protected LeftSide: HTMLElement[] = [];
    protected RightSide: HTMLElement[] = [];
    protected LeftView: HTMLElement = null
    protected RightView: HTMLElement = null;
    
    protected slideFactoryLeft: SlideFactory2Side = null;
    protected slideFactoryRight: SlideFactory2Side = null;
    protected logGroup: LogGroup = null;
    protected paytable: PayTable = null;
    protected symbolSpriteAnims: SlotSymbolSprite[] = [];
    protected viewSize: Size = null;


	protected featuresleft: SlideType[] = [];
	protected featuresright: SlideType[] = [];

	protected helpSlidesLeft: Slide[] = [];
	protected helpSlidesRight: Slide[] = [];
	
	protected allSlides: Slide[] = [];
	

	protected currentLeftSlideIndex: number = 0;
	protected currentLeftSlide: Slide;
	protected nextLeftSlide: Slide;

	protected currentRightSlideIndex: number = 0;
	protected currentRightSlide: Slide;
	protected nextRightSlide: Slide;


	protected nextSlideTimer: IInterval;

	protected params: SecondScreenHelpParams;

	protected pauseTimer: ITimeout;
	protected pauseRequested: boolean = false;

    constructor(params: SecondScreenHelpParams) {
		this.params = params;
        this.systemContext = params.systemContext.CreateSubContext("SliderDoubleSide");
        this.translator = params.translator;
        this.initData = params.initData;
        this.logGroup = params.logGroup.Add("SliderDoubleSide");
        this.resid = params.resid.Add("SliderDoubleSide");
        this.gamePath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/resources/";
        this.commonPath = Settings.ResourcesFolder + "multigame/slot/common/Slider2/";
        //this.commonPath3 = Settings.ResourcesFolder + "multigame/slot/common/";
        this.symbolSpriteAnims = params.symbolSpriteAnims;
        this.viewSize = params.viewSize;

        this.translator = params.translator;
        this.view = CreateElement("div", {
            classes: ["slideShow"],
            style: {
                overflow: "hidden",
                height: Scale.Hpx(610),
                width: Scale.Wpx(1920),
                bottom: Scale.Ypx(0),
                position: "absolute"
            }
        });




		this.PrepareSlides();

        // this.nextSlideTimerLeft = this.systemContext.TimingContext().CreateInterval("nextSlideTimerLeft", this.nextSlideInterval, () => this.NextSlideLeft());
		// this.nextSlideTimerRight = this.systemContext.TimingContext().CreateInterval("nextSlideTimerRight", this.nextSlideInterval, () => this.NextSlideRight());

		this.pauseTimer = this.systemContext.TimingContext().CreateTimeout("pauseTimer", 10000, () => this.PauseTimerElapsed());
    }

	PauseTimerElapsed()
	{
		this.pauseRequested = false;
	}

	public PrepareSlides()
	{
		this.slideFactoryLeft = new SlideFactory2Side();
        this.slideFactoryRight = new SlideFactory2Side();
        

        if (this.initData.BonusConfiguration && this.initData.BonusConfiguration.FreeGameBonus) {
            this.featuresleft.push(SlideType.FreeGameBonus);
            this.featuresright.push(SlideType.FreeGamePlusOne);
        }

        if (this.initData.BonusConfiguration && this.initData.BonusConfiguration.BigSymbolFreegames) {
            this.featuresleft.push(SlideType.BigFreeGameBonus);
            this.featuresright.push(SlideType.BigFreeGamePlusOne);
        }

        if (this.initData.BonusConfiguration && this.initData.BonusConfiguration.SpinAndHold) {
            this.featuresleft.push(SlideType.HoldAndSpinLeft);
            this.featuresright.push(SlideType.HoldAndSpinRight);
        }





        if (this.initData.Feature.includes("ExpandingWildBulk")) {
            this.featuresleft.push(SlideType.ExpandingWildBulkLeft);
            this.featuresright.push(SlideType.ExpandingWildBulkRight);
        }

        else if (this.initData.Feature.includes("ExpandingWildReel")) {
            this.featuresleft.push(SlideType.ExpandingWildReelLeft);
            this.featuresright.push(SlideType.ExpandingWildReelRight);
        }
        else {
            this.featuresleft.push(SlideType.Wild);
        }

        if (this.initData.BonusConfiguration && this.initData.BonusConfiguration.PickBonus) {
            //this.featuresleft.push("PickBonus");
            //this.featuresright.push("ProgressivePickBonus");
            //this.featuresright.push("Jp");

		}

		if (this.params.backendSettings.GetBool("play.turbo"))
		{
			this.featuresleft.push(SlideType.BigFreeGamePlusOne);
			this.featuresright.push(SlideType.TurboPlay);
		}


		
        //DiamondSpin
        // if (this.initData.BonusConfiguration && this.initData.BonusConfiguration.DiamondSpin) {
        //     this.featuresright.push(SliedType.DiamondSpin);
        // }

		let slideParams: SlideFactory2Params = {
			gameName: this.params.gameName,
			path: this.gamePath, 
			resid: this.resid, 
			commonPath: this.commonPath, 
			slideFactory: this.slideFactoryLeft, 
			translator: this.translator, 
			params: this.initData.BonusConfiguration, 
			logGroup: this.logGroup, 
			systemContext: this.systemContext
		}


		for (let i = 0; i < this.featuresleft.length; i++) 
		{
			let slide: Slide = this.slideFactoryLeft.CreatSlide2side(this.featuresleft[i], this.initData, slideParams , new Size(Scale.W(763) , Scale.H(582)))
			
			this.helpSlidesLeft.push(slide);
			this.allSlides.push(slide);
		}

		for (let i = 0; i < this.featuresright.length; i++) 
		{
			let slide: Slide = this.slideFactoryRight.CreatSlide2side(this.featuresright[i], this.initData, slideParams , new Size(Scale.W(763) , Scale.H(582)));
			
			this.helpSlidesRight.push(slide);
			this.allSlides.push(slide);
		}

		this.nextSlideTimer = this.systemContext.TimingContext().CreateInterval("nextSlideTimer", this.nextSlideInterval, () => this.NextSlide());

	}

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {


		for (let i = 0; i < this.allSlides.length; i++) 
		{
			await this.allSlides[i].PrepareResources(resourceManager);
		}

		this.PaytablePrepare(resourceManager);
	}

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.PaytableLoaded(resourceManager);

        this.LeftView = CreateElement("div", {
            classes: ["LeftView"],
            parentToAppend: this.view,
            style: {
                top: "0px",
                left: Scale.Xpx(50),
                position: "absolute",
                width: Scale.Wpx(697),
                height: Scale.Hpx(582),
                display: "flex",
                flexDirection: "row",
            }
        });

        this.RightView = CreateElement("div", {
            classes: ["RightView"],
            parentToAppend: this.view,
            style: {
                position: "absolute",
                top: "0px",
                width: Scale.Wpx(697),
                height: Scale.Hpx(582),
                display: "flex",
                flexDirection: "row",
                right: "0px",
            }
        });

		for (let i = 0; i < this.allSlides.length; i++)
		{
			await this.allSlides[i].ResourcesLoaded(resourceManager);
			SetStyles(this.allSlides[i].View(), {
				willChange: "transform, opacity"
			});
			TweenLite.set(this.allSlides[i].View(), {autoAlpha: 0});
		}

		for (let i = 0; i < this.helpSlidesLeft.length; i++) 
		{
			this.LeftView.appendChild(this.helpSlidesLeft[i].View());
		}

		for (let i = 0; i < this.helpSlidesRight.length; i++) 
		{
			this.RightView.appendChild(this.helpSlidesRight[i].View());
		}

		if (this.helpSlidesLeft.length >=1)
		{
			this.currentLeftSlideIndex = 0;
			this.currentLeftSlide = this.helpSlidesLeft[0];
		}
		if (this.helpSlidesRight.length >= 1)
		{
			this.currentRightSlideIndex = 0;
			this.currentRightSlide = this.helpSlidesRight[0];
		}
    }

    protected PaytablePrepare(resourceManager: IWriteOnlyResourceManager): void {
        // resourceManager.Add(new CSSResource(this.commonPath3 + "resources/paytable.css", this.resid.ScopedResourceName(["paytable", "css"]), this.resid.CSSScope()));
        // resourceManager.Add(new ImageResource(this.gamePath + "paytable.png", this.resid.ScopedResourceName(["paytable", "background"])));

    }

    protected PaytableLoaded(resourceManager: IReadOnlyResourceManager) {
        //    this.paytable = new PayTable(this.initData.paytable, this.symbolSpriteAnims, this.viewSize);

        // 	//let paytableView = this.paytable.View();
        // 	//paytableView.style.top = "700px";

        // 	//this.view.querySelector(".paytable-container").appendChild(this.paytable.View());
        // 	debugger
        // 	SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
        // 	{
        // 		backgroundImage : resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["paytable", "background"])).CssBackground(),
        // 		borderRadius:"0px",

        // 	});

        // 	this.paytable.Update(true);
    }


	protected leftAnim: TimelineMax = null;
	protected rightAnim: TimelineLite = null;

	protected NextSlide()
	{
		if (this.pauseRequested)
		{
			// don't do anything
			return;
		}

		let transitionMillis = 1000;
		let animDistance = 500;

		// left
		if (this.helpSlidesLeft.length > 1)
		{
			
			let currentLeftSlide = this.currentLeftSlide;

			let nextLeftSlideIndex = (this.currentLeftSlideIndex +1) % this.helpSlidesLeft.length;
			let nextLeftSlide = this.helpSlidesLeft[nextLeftSlideIndex];
			this.nextLeftSlide = nextLeftSlide;

			//// Log.Debug(this.logGroup, `NextSlide() currentLeftSlideIndex: ${this.currentLeftSlideIndex}, nextLeftSlideIndex: ${nextLeftSlideIndex}`);

			this.leftAnim = new TimelineMax({paused: true});

			// current slide: mode left fade out
			this.leftAnim.fromTo(this.currentLeftSlide.View(), transitionMillis / 1000, { x: 0, autoAlpha: 1, scale: 1}, { x: -animDistance, autoAlpha: 0, scale: 0 });

			// next slide: move right fade in
			this.leftAnim.fromTo(nextLeftSlide.View(), transitionMillis / 1000, { x: -animDistance, autoAlpha: 0, scale: 0}, { x: 0, autoAlpha: 1, scale: 1 }, "-=" + (transitionMillis / 1000));

			this.leftAnim.eventCallback("onStart", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition started, starting next slide");
				nextLeftSlide.Start();
			});

			this.leftAnim.eventCallback("onComplete", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition complete, stopping current slide");
				currentLeftSlide.Stop();

				this.currentLeftSlideIndex = nextLeftSlideIndex;
				this.currentLeftSlide = nextLeftSlide;
				this.nextLeftSlide = null;
			});

			this.leftAnim.play();
		}

		// right
		if (this.helpSlidesRight.length > 1)
		{
			let currentRightSlide = this.currentRightSlide;
			
			let nextRightSideIndex = (this.currentRightSlideIndex +1) % this.helpSlidesRight.length;
			let nextRightSlide = this.helpSlidesRight[nextRightSideIndex];
			this.nextRightSlide = nextRightSlide;

			//// Log.Debug(this.logGroup, `NextSlide() currentRightSlideIndex: ${this.currentRightSlideIndex}, nextRightSideIndex: ${nextRightSideIndex}`);

			let slideWidth = 0

			this.rightAnim = new TimelineMax({paused: true});
			// current slide: mode right fade out
			this.rightAnim.fromTo(this.currentRightSlide.View(), transitionMillis / 1000, { x: 0, autoAlpha: 1, scale: 1}, { x: animDistance, autoAlpha: 0, scale: 0 });

			// next slide: move right fade in
			this.rightAnim.fromTo(nextRightSlide.View(), transitionMillis / 1000, { x: animDistance, autoAlpha: 0, scale: 0}, { x: 0, autoAlpha: 1, scale: 1 }, "-=" + (transitionMillis / 1000));

			this.rightAnim.eventCallback("onStart", () => {
				nextRightSlide.Start();
			});

			this.rightAnim.eventCallback("onComplete", () => {
				currentRightSlide.Stop();

				this.currentRightSlideIndex = nextRightSideIndex;
				this.currentRightSlide = nextRightSlide;
				this.nextRightSlide = null;
			});

			this.rightAnim.play();
		}
	}


    protected started = false;
    public Start(): void {
        if (!this.started) {
			this.started = true;
			this.nextSlideTimer.Start();

			if (this.helpSlidesLeft.length >= 1)
			{
				TweenLite.set(this.currentLeftSlide.View(), {scale: 1, x: 0, autoAlpha: 1});
				this.currentLeftSlide.Start();
			}

			if (this.helpSlidesRight.length >= 1)
			{
				TweenLite.set(this.currentRightSlide.View(), {scale: 1, x: 0, autoAlpha: 1});
				this.currentRightSlide.Start();
			}
		}
		else
		{
			// already started
		}
    }

    public Stop(): void {
		if (this.started)
		{
			this.started = false;
			this.nextSlideTimer.Stop();

			// stop all sprites
			this.allSlides.forEach(s => s.Stop());
		}
    }

    public Reset():void
    {
        // if (this.helpSlidesLeft.length > 1 && this.helpSlidesRight.length > 1)
        // {
        //     TweenLite.set(this.helpSlidesLeft[this.currentLeftSlideIndex].View(), { x: (10) + "%" });
        //     TweenLite.set(this.helpSlidesRight[ this.currentRightSlideIndex].View(), { x: (-10) + "%" });
        // }
    }

    public View(): HTMLElement {
        return this.view;
    }

    public Hide(): void {
        this.view.style.visibility = "hidden";
    }

	public Update(): void {

		// update current and next slide
		if (this.started)
		{
			this.currentLeftSlide?.Update();
			this.nextLeftSlide?.Update();

			this.currentRightSlide?.Update();
			this.nextRightSlide?.Update();
		}
	}

	public SetBet(message: SlotGameMessages.BetChange) 
	{
	}
	
	public PayTableUpdate(force?: boolean) 
	{
	}

	public RequestPause(): void {
		this.pauseRequested = true;
		this.pauseTimer.Restart();
	}
}



